import { images } from "@constants";
import { useTranslation } from "react-i18next";
import { EmptyContainer } from "./EmptyResultStyled";
import { Col, Row } from "antd";

const EmptyResultComponent = () => {
  const { t } = useTranslation();

  return (
    <EmptyContainer>
      <div style={{ paddingTop: "100px", height: "500px" }}>
        <Row justify={"center"}>
          <Col>
            <img
              className="no-result-image"
              src={images.noResult}
              alt="no_result"
            />
            <p className="no-result-msg">{t("COMMON_MSG.NO_RESULT_MSG")}</p>
          </Col>
        </Row>
      </div>
    </EmptyContainer>
  );
};

export { EmptyResultComponent };
